module.exports = __webpack_public_path__ + "img/plane-app.3f11f932.png";